<template>

  <v-layout class="inner-pages" column :style="{height: $store.getters.getAppHeight + 'px'}">
    <Header :header-height="$auth.check() ? '70px': '120px'" />

    <scroll-data>
      <div>
        <v-flex class="pt-0">
          <h2 class="page-head"><span class="page-heading">User License and Terms of Use Agreement</span></h2>
          <div>
            <p>You are signing up for a cogneti certificate program. By participating in this program you acknowledge that you have read and agree that
              the following terms and conditions govern your use of the program materials, your course examination and your use of the course
              certificate.</p>
            <p>You understand that full course access and certificate issue are only available with a valid and fully paid license.</p>
            <p>This Agreement is between you (the individual) and Cogneti, LLC, as described below. By accepting this Agreement, it is understood that
              you have read the Agreement and that you agree to abide by the Agreement.</p>
            <p>Each certificate has a fixed validity from the date of issue. This certificate can be verified using the Cogneti website.</p>
            <ol>
              <li>
                <strong>Cogneti Issued Certificates and Badges</strong>
                <ul>
                  <li><strong>You agree</strong> that payment is required to access all levels and the course certificate exam.
                  </li>
                  <li>You may use the Cogneti Certificate and issued Badge as proof and representation of your successful completion of the Certificate
                    Program.</li>
                  <li>You agree to keep Cogneti Certificate Program material, examination results, and all other course communications confidential. You will
                    not use this course information for any reason other than to earn and gain the issued certificate.</li>
                  <li>You will not give the rights of your certificate(s) to any other person.</li>
                  <li>You agree not to misrepresent the Certificate or the Badge or to harm the reputation of Cogneti, LLC.</li>
                  <li>You agree to comply with all applicable federal, state, and local laws and codes in the practice of your service or business.</li>
                  <li>You understand that the Cogneti Certificate and the Badge may increase your chances of gainful employment. However, you will not
                    hold Cogneti, LLC, their officers, directors, employees, agents or successors and assignees liable for any or all harm in the event of
                    unemployment.
                  </li>
                  <li>You agree that Cogneti, LLC, their officers, directors, employees, agents, or successor and assignees are not liable for any direct or
                    indirect or special damage(s) you may cause to person or place of business during the performance of your duties while being a
                    Cogneti Certificate or Badge Holder.</li>
                  <li>You also agree that all feedback you give Cogneti, LLC for its course or exam will become the property of Cogneti, LLC, without
                    payment, royalties, or other consideration to you.</li>
                  <li>This Agreement is governed by the laws of the Country in where the examination is taken or, if different, the Country of residence of the
                    individual taking the course(s) and the courts of that Country will have jurisdiction over matters.</li>
                </ul>
              </li>
              <li>
                <strong>Course license</strong>
                <ul>
                  <li>Full license fee payment is required to access all course content, to receive and complete the examination, and to be issued a
                    Certificate or Badge.
                  </li>
                  <li>
                    The license is valid only through the term of validity of each Cogneti Certificate Program.
                    </li>
                  <li>The license permits you to access the course material and all.</li>
                  <li>You agree that this is a non-exclusive license to a specific Cogneti, LLC course. The course remains the property of the licensor who is
                    the owner of all rights, titles, and interest in the software. No copies of the software will be made by yourself or others unless expressly
                    authorized by Cogneti.</li>
                </ul>
              </li>
              <li><strong>Invalidating a Certificate</strong>
                <ul>
                  <li><strong>You agree</strong> if you are found to have violated any terms of this agreement, any current certificate(s) you hold will be invalidated, and you
                    will be permanently ineligible for any future Cogneti certificate(s) and that all current certificate(s) will be removed from our searchable
                    database.
                  </li>
                  <li>You will be informed by email of the invalidation of your Certificate or of your Badge.</li>
                  <li>Once notification from Cogneti has been received, you must cease using the Cogneti Certificate and Badge, all associated logos, and
                    any written acknowledgment.
                  </li>
                  <li>If you believe this action was taken in error, you may use our Grievance Process listed below.</li>
                </ul>
              </li>

              <li>
                <strong>Personal Information</strong>
                <ul>
                  <li><strong>You agree</strong> that Cogneti, LLC will collect, process and use your data to process and track license fee payment for the course, the
                    Certificate, your individual performance, exam scores, and your compliance with this Agreement.
                  </li>
                  <li>In all other ways, Cogneti, LLC will protect the information that we hold. Please review our privacy
                    policy at&nbsp;<a class="external-link" href="https://cogneti.com/home/privacy" rel="nofollow noopener"
                                      target="_blank">https://cogneti.com/home/privacy</a>.
                  </li>
                  <li>Submit a support request to Cogneti, LLC if you wish to change your contact information.</li>
                </ul>

              </li>

              <li>
                <strong>Refunds</strong>
                <ul>
                  <li>All license-fee sales are final.
                  </li>
                  <li>Refunds may be requested by issuing a support request.
                  </li>
                  <li>
                    Consideration of the refund request will be made solely at the discretion of Cogneti staff.
                  </li>
                </ul>
              </li>

              <li>
                <strong>Grievance, Appeal, Feedback and Support Process</strong>
                <div>As part of the User License Agreement, you may contact Cogneti for any of the following purposes.</div>
                <ul>
                  <li>Record a <strong>grievance</strong> or complaint about the Certificate Program</li>
                  <li>Request an <strong>appeal</strong> of an examination score or result.</li>
                  <li>Provide <strong>feedback</strong> on the Certificate Program or mobile application.</li>
                  <li>Request <strong>support</strong> for service, information, or other action.</li>
                </ul>
                <div>You must initiate such actions using one of the following methods.</div>
                <ul>
                  <li>The Feedback & Support function within the available web or mobile app</li>
                  <li>The Support link on the <a href="https://cogneti.com" target="_blank">Cogneti.com</a> website</li>
                  <li>Sending an email to <a href="mailto:support@cogneti.com" target="_blank">support@cogneti.com</a></li>
                </ul>
                <p>Cogneti shall identify all such requests with a tracking number and categorize for action as a grievance,
                  appeal, feedback, or support request.

                </p>
                <p>Grievances or appeals must be submitted through the app or email within 14 business days from the date of the event. Cogneti will
                  respond via email within five business days with our decision. If you would like to further appeal, you may submit an appeal of our decision
                  within 14 business days. Within five additional business days we will review your appeal and issue a written final and binding decision. No
                  additional appeals will be heard after our final and binding decision.</p>
                <p>Cogneti will attempt to provide an initial response to all support requests within 48 hours.

                </p>
                <p>Cogneti will record feedback and make it available during periodic program review and audit.

                </p>

              </li>
              <li><strong>Americans with Disabilities Act (ADA)</strong>
                <p>
                  Cogneti follows all applicable provisions of the Americans With Disabilities Act (ADA) and will not discriminate against any individual
                  applying to take any of our courses due to a disability as defined by the ADA. Cogneti will provide reasonable accommodations to a person
                  with a disability (defined by the ADA) who has informed us of that disability, provided that any accommodations will not constitute an undue
                  hardship to the company. If special accommodation is required, you should contact Cogneti at <a
                  class="external-link" href="mailto:contact@cogneti.com" rel="nofollow">contact@cogneti.com</a>. We will consider all
                  factors including, but not limited to, the cost and nature of accommodations, available tax credits, deductions, or outside funding, and
                  decide if we can provide the requested accommodations. Cogneti will inform you of their decision on the request. If we deny your request,
                  you may enter a written appeal which includes statements of why the accommodations are necessary. We will review the request, and if
                  the appeal is denied, that decision is final.
                </p>
              </li>
              <li><strong>Equal Opportunity &amp; Non-Discrimination</strong>
                <p>Our courses are open and available to all persons, worldwide. Cogneti follows the law in policies that separate or exclude individuals due
                  to their race, color, religion, national origin, disability, age, sex, sexual preference, or on any other protected category.</p>
              </li>
              <li><strong>General Program Notifications</strong>
                <p>Cogneti, LLC does not receive any commercial or third-party support in the creation of the certificate programs. The awarding of a
                  certificate is based solely on the individual performance of the student.
                </p>
              </li>
            </ol>
          </div>
        </v-flex>
      </div>
    </scroll-data>

  </v-layout>
</template>

<script>
  import ScrollData from '../../../ScrollData'
  import Header from '../../../layouts/Header'
  export default {
    name: 'TermsOfUse',
    components: {Header, ScrollData},
    data () {
      return {
        appName: process.env.APP_NAME,
        offsetTop: 0,
        scrollHeight: 0,
        scrolled: 0,
        gameId: process.env.GAME_ID

      }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    mounted () {
      this.scrollHeight = this.$store.getters.getAppHeight - 190
    },
    methods: {
      goTo (elem) {
        const element = document.getElementById(elem)
        element.scrollIntoView({behavior: 'smooth'})
      },
      handleScroll () {
        this.scrolled = window.scrollY
      },
      onScroll (e) {
        const top = e.target.scrollTop
        if (top > 300) {
          this.header = false
          this.appHeight = this.$store.getters.getAppHeight
        } else {
          this.header = true
          this.appHeight = this.$store.getters.getAppHeight - 190
        }
      }
    }
  }
</script>
<style lang="stylus">
@import '../../../../../node_modules/vuetify/src/stylus/main.styl';
ol ol {
  list-style: lower-alpha;
}
ul.go-to-links > li{
  color: $blue.darken-1;
  cursor: pointer;
}
  h4 {
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/guest/TermsOfUse/index.vue